import { createSlice } from "@reduxjs/toolkit";
import { fetchIndustry_sector_parentItems } from "./Industry_sector_parentThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const industry_sector_parentSlice = createSlice({
  name: "industry_sector_parent",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchIndustry_sector_parentItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustry_sector_parentItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchIndustry_sector_parentItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default industry_sector_parentSlice.reducer;